import React, { useState, useEffect, useLayoutEffect } from "react";
import Modal from "components/UI/Modal/Modal";
import { InsertModal, UpdateModal, DeleteModal } from "./Actions";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { routeInfo, userCredentials } from "recoilState/GlobalState";
import { HeaderButton } from "components";
import Add from "@mui/icons-material/Add";
import Cached from "@mui/icons-material/Cached";
import EditOutlined from "@mui/icons-material/EditOutlined";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { Buttons } from "components";
import { ACTIONS } from "consts/Actions";
import { zonasTitles as titles } from "consts/titulos-de-tablas";
import styles from "styles/pages/Pages.module.scss";
import { useService, puedeEditarServicio } from "components/route/ServiceRoute";
import XGrid from "components/UI/Grid/XGrid";
import { RNHZonaGet } from "services/services-mia/programa-salud/estructuras/RNHZonaGet";

export default function Zonas() {
  const credentials = useRecoilValue(userCredentials);
  const setRoute = useSetRecoilState(routeInfo);
  const [modalDetails, setModalDetails] = useState({ isOpen: false });
  const [loading, setLoading] = useState(false);
  const [zonas, setZonas] = useState([]);
  const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
  const { service } = useService();

  const getZonas = async () => {
    setZonas([]);
    setRowSelected({ status: false, row: {} });
    setLoading(true);
    const { data: result } = await RNHZonaGet(credentials);
    const newRows = result[0]?.rnhZonaCod ? result?.map((data) => {
      return {
        id: data.rnhZonaId,
        cod: data.rnhZonaCod,
        name: data.rnhZonaNombre,
        wkt: data.rnhZonaWKT,
        hospitalCabecera: data.rnhEstablecimientoCabeceraZonaNombre || 'Sin asignar',
        // No es columna: viaja en la fila para que Modificar y Eliminar no tengan que
        // volver a pedir el registro.
        version: data.rnhZonaVersion,
      };
    }) : []
    setZonas(newRows);
    setLoading(false);
  }
  const closeModal = () => {
    setModalDetails({ isOpen: false });
  };
  const handleClick = ({ procede, title }) => {
    setModalDetails({ procede, title, isOpen: true });
  };

  useEffect(() => {
    getZonas()
  }, [])
  useLayoutEffect(() => {
    setRoute({
      wordKey: `Zonas - Programa Salud RN`
    })
  }, [service.servicioNombre, setRoute])

  return (
    <main className={styles.main}>
      <Modal size={modalDetails.procede === ACTIONS.DELETE ? 'sm' : 'md'} open={modalDetails.isOpen} title={modalDetails.title} onClose={closeModal}>
        {modalDetails.procede === ACTIONS.UPDATE && (
          <UpdateModal
            row={rowSelected.row}
            updateList={getZonas}
            closeModal={closeModal}
          />
        )}
        {modalDetails.procede === ACTIONS.DELETE && (
          <DeleteModal
            row={rowSelected.row}
            servicio={service}
            updateList={getZonas}
            closeModal={closeModal}
            setterRowSelected={setRowSelected}
          />
        )}
        {modalDetails.procede === ACTIONS.INSERT && (
          <InsertModal
            servicio={service}
            updateList={getZonas}
            closeModal={closeModal}
          />
        )}
      </Modal>
      <div className={styles["filters-actions-right"]}>
        <Buttons>
          <HeaderButton
            text={"Actualizar"}
            onClick={() => { getZonas() }}
            disabled={rowSelected.row.id || false}
          >
            <Cached />
          </HeaderButton>
          <HeaderButton
            text={"Nueva Zona"}
            handleClick={handleClick}
            data={{
              title: "Nueva Zona",
              procede: ACTIONS.INSERT
            }}
            disabled={rowSelected.row.id || service.servicioPermiso !== 'E'}
          >
            <Add />
          </HeaderButton>
          <HeaderButton
            text={"Modificar Zona"}
            handleClick={handleClick}
            data={{
              title: "Modificar Zona",
              procede: ACTIONS.UPDATE
            }}
            disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
          >
            <EditOutlined />
          </HeaderButton>
          <HeaderButton
            text={"Eliminar Zona"}
            handleClick={handleClick}
            data={{
              title: "Eliminar Zona",
              procede: ACTIONS.DELETE
            }}
            disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
          >
            <DeleteOutlineRoundedIcon />
          </HeaderButton>
        </Buttons>
      </div>
      <div className={styles.container}>
        <XGrid
          rows={zonas}
          titles={titles}
          loading={loading}
          secondarySelected={rowSelected}
          setSecondarySelected={setRowSelected}
        />
      </div>
    </main>
  );
}